<template>
    <div class="role_warp">
      <!-- 头部工具栏 -->
      <div class="role_heard_tool">
        <el-button
          type="success"
          size="mini"
          style="margin-bottom: 5px;"
          @click="getDate()"
          >刷新</el-button
        >
        <el-button
          type="primary"
          class="edit-button"
          size="mini"
          style="margin-left: 10px;margin-bottom: 5px;"
          @click="select()"
          >筛选</el-button
        > 
        <el-button
          type="primary"
          class="edit-button"
          size="mini"
          style="margin-left: 10px;background: #06CC00;border:1px solid #06CC00;margin-bottom: 5px;"
          @click="zhuanTrx()"
          >转POL</el-button
        >
        <el-button
          type="primary"
          class="edit-button"
          size="mini"
          style="margin-left: 10px;background: #06CC00;border:1px solid #06CC00;margin-bottom: 5px;"
          @click="getZhuList(1)"
          >归集POL</el-button
        >
        <!-- <el-button
          type="primary"
          class="edit-button"
          size="mini"
          style="margin-left: 10px;background: #FF0000;border:1px solid #FF0000;margin-bottom: 5px;"
          @click="getZhuList(2)"
          >归集TRX</el-button
        > -->
        <!-- <el-button
          type="primary"
          class="edit-button"
          size="mini"
          style="margin-left: 10px;background: #0C7DFF;border:1px solid #0C7DFF;margin-bottom: 5px;"
          @click="getDelegatedEnergy()"
          >代理能量</el-button
        >
        <el-button
          type="primary"
          class="edit-button"
          size="mini"
          style="margin-left: 10px;background: #0C7DFF;border:1px solid #0C7DFF;margin-bottom: 5px;"
          @click="undelegateResource()"
          >回收能量</el-button
        > -->
        <el-button
          type="primary"
          class="edit-button"
          size="mini"
          style="margin-left: 10px;background: #FF7845;border:1px solid #FF7845;margin-bottom: 5px;"
          @click="getZhuList(4)"
          >归集USDT</el-button
        >
        <!-- <el-button
          type="primary" 
          class="edit-button"
          size="mini"
          style="margin-left: 10px;background: #FF7845;border:1px solid #FF7845;margin-bottom: 5px;"
          @click="getZhuList(3)"
          >一键归U</el-button
        > -->
        <el-button
          type="primary"
          class="edit-button"
          size="mini"
          style="margin-left: 10px;background: #6663FF;border:1px solid #6663FF;margin-bottom: 5px;"
          @click="batchFreshUSDT()"
          >一键刷新</el-button
        >
        <el-button
          type="primary"
          class="edit-button"
          size="mini"
          style="margin-left: 10px;background: #6663FF;border:1px solid #6663FF;margin-bottom: 5px;"
          @click="resetStatus()"
          >重置归集状态</el-button
        >
        <el-button
          type="primary"
          class="edit-button"
          size="mini"
          style="margin-left: 10px;background: #008A8B;border:1px solid #008A8B;margin-bottom: 5px;"
          @click="batchFreshAssetOther()"
          >一键刷新其他币种</el-button
        >
        <!-- <el-button
          type="primary"
          class="edit-button"
          size="mini"
          style="margin-left: 10px;background: #008A8B;border:1px solid #008A8B;margin-bottom: 5px;"
          @click="getZhuList(5,'BTC')"
          >归集BTC</el-button
        >
        <el-button
          type="primary"
          class="edit-button"
          size="mini"
          style="margin-left: 10px;background: #008A8B;border:1px solid #008A8B;margin-bottom: 5px;"
          @click="getZhuList(5,'POL')"
          >归集POL</el-button
        > -->
        <el-button
          type="primary"
          class="edit-button"
          size="mini"
          style="margin-left: 10px;background: #008A8B;border:1px solid #008A8B;margin-bottom: 5px;"
          @click="getZhuList(5,'USDC')"
          >归集USDC</el-button
        >
        <el-button
          type="primary"
          class="edit-button"
          size="mini"
          style="margin-left: 10px;background: #008A8B;border:1px solid #008A8B;margin-bottom: 5px;"
          @click="getZhuList(5,'ETH')"
          >归集ETH</el-button
        >
        <el-button
          type="primary"
          class="edit-button"
          size="mini"
          style="margin-left: 10px;background: #008A8B;border:1px solid #008A8B;margin-bottom: 5px;"
          @click="getZhuList(5,'DAI')"
          >归集DAI</el-button
        >
        <!-- <el-button
          type="primary"
          class="edit-button"
          size="mini"
          style="margin-left: 10px;background: #008A8B;border:1px solid #008A8B;margin-bottom: 5px;"
          @click="getZhuList(5,'DOGE')"
          >归集DOGE</el-button
        > -->
  
        <!-- <div class="guiJi">
          <div class="guiJi_title">归集进度：{{ca1 || 0}}/{{ca2 || 0}}</div>
          <el-button type="text" @click="getCollectList">详情</el-button>
          <el-button type="text" @click="collectListRemove">清空</el-button>
        </div> -->
      </div>
      <div class="head_search">
        <div class="item_warp">
          <label style="margin: 0 10px">用户</label>
          <el-input
            v-model="uid"
            placeholder="请输入uid"
            style="width: 120px"
            size="mini"
            clearable
          />
        </div>
        <!-- <div class="item_warp">
          <label style="margin: 0 10px">账号</label>
          <el-input
            v-model="username"
            placeholder="请输入账号"
            style="width: 120px"
            size="mini"
            clearable
          />
        </div> -->
        <div class="item_warp">
          <label style="margin: 0 10px">未归集USDT ></label>
          <el-input
            v-model="unCollectAmount"
            placeholder="请输入未归集金额" 
            style="width: 120px"
            size="mini"
            clearable
          />
        </div>
        <!-- <div class="item_warp">
          <label style="margin: 0 10px">未归集Trx ></label>
          <el-input
            v-model="unCollectTrx"
            placeholder="请输入未归集Trx"
            style="width: 120px"
            size="mini"
            clearable
          />
        </div> -->
        <!-- <div class="item_warp">
          <label style="margin: 0 10px">未归集BTC ></label>
          <el-input
            v-model="unCollectBtc"
            placeholder="请输入未归集BTC"
            style="width: 120px"
            size="mini"
            clearable
          />
        </div> -->
        <div class="item_warp">
          <label style="margin: 0 10px">未归集POL ></label>
          <el-input
            v-model="unCollectPOL"
            placeholder="请输入未归集POL"
            style="width: 120px"
            size="mini"
            clearable
          />
        </div>
        <div class="item_warp">
          <label style="margin: 0 10px">未归集USDC ></label>
          <el-input
            v-model="unCollectUsdc"
            placeholder="请输入未归集USDC"
            style="width: 120px"
            size="mini"
            clearable
          />
        </div>
        <div class="item_warp">
          <label style="margin: 0 10px">未归集ETH ></label>
          <el-input
            v-model="unCollectEth"
            placeholder="请输入未归集ETH"
            style="width: 120px"
            size="mini"
            clearable
          />
        </div>
        <div class="item_warp">
          <label style="margin: 0 10px">未归集DAI ></label>
          <el-input
            v-model="unCollectDai"
            placeholder="请输入未归集DAI"
            style="width: 120px"
            size="mini"
            clearable
          />
        </div>
        <!-- <div class="item_warp">
          <label style="margin: 0 10px">未归集Doge ></label>
          <el-input
            v-model="unCollectDoge"
            placeholder="请输入未归集Doge"
            style="width: 120px"
            size="mini"
            clearable
          />
        </div> -->
        <div class="item_warp">
          <label style="margin: 0 10px">币安钱包地址</label>
          <el-input
            v-model="address"
            placeholder="请输入账号钱包地址"
            style="width: 120px"
            size="mini"
            clearable
          />
        </div>
        <!-- <div class="item_warp">
          <label style="margin: 0 10px">代理能量 ></label>
          <el-input
            v-model="delegatedEnergy"
            placeholder="请输入代理能量"
            style="width: 120px"
            size="mini"
            clearable
          />
        </div> -->
         <div class="item_warp">
          <label style="margin: 0 10px">POL余额</label>
          <el-select v-model="hasTrx" placeholder="请选择" style="width: 120px" clearable>
            <el-option label="不限" value=""></el-option>
            <el-option label="有POL" value="true"></el-option>
            <el-option label="无POL" value="false"></el-option>
          </el-select>
        </div>
        <div class="item_warp">
          <label style="margin: 0 10px">已归集USDT</label>
          <el-select v-model="isHadCollectAmount" placeholder="请选择" style="width: 120px" clearable>
            <el-option label="不限" value=""></el-option>
            <el-option label=">0" value="true"></el-option>
            <el-option label="=0" value="false"></el-option>
          </el-select>
        </div>
        <!-- <div class="item_warp">
          <label style="margin: 0 10px">剩余代理能量</label>
          <el-select v-model="hasEnergy" placeholder="请选择" clearable>
            <el-option label="不限" value=""></el-option>
            <el-option label="有能量" value="true"></el-option>
            <el-option label="无能量" value="false"></el-option>
          </el-select>
        </div> -->
        <div class="item_warp">
          <label style="margin: 0 10px">USDT归集状态</label>
          <el-select v-model="collectUsdtStatus" placeholder="请选择" style="width: 120px" clearable>
            <el-option label="不限" value=""></el-option>
            <el-option label="无" :value="0"></el-option>
            <el-option label="归集成功" :value="1"></el-option>
            <el-option label="归集失败" :value="2"></el-option>
            <el-option label="归集中" :value="3"></el-option>
          </el-select>
        </div>
        <!-- <div class="item_warp">
          <label style="margin: 0 10px">TRX归集状态</label>
          <el-select v-model="collectTrxStatus" placeholder="请选择" style="width: 120px" clearable>
            <el-option label="不限" value=""></el-option>
            <el-option label="无" :value="0"></el-option>
            <el-option label="归集成功" :value="1"></el-option>
            <el-option label="归集失败" :value="2"></el-option>
            <el-option label="归集中" :value="3"></el-option>
          </el-select>
        </div> -->
        <div class="item_warp">
          <label style="margin: 0 10px">其他币种归集状态</label>
          <el-select v-model="collectOtherStatus" placeholder="请选择" style="width: 120px" clearable>
            <el-option label="不限" value=""></el-option>
            <el-option label="无" :value="0"></el-option>
            <el-option label="归集成功" :value="1"></el-option>
            <el-option label="归集失败" :value="2"></el-option>
            <el-option label="归集中" :value="3"></el-option>
          </el-select>
        </div>
      </div>
      <div class="head_search">
        <div class="item_warp"> 
          <div style="color: red">未归集：USDT {{ totalRechargeCunt.unCollectUsdt}}</div>
        </div>
        <!-- <div class="item_warp" style="margin-left: 10px;">
          <div style="color: red">/ TRX {{ totalRechargeCunt.unCollectTrx }}</div>
        </div>
        <div class="item_warp" style="margin-left: 10px;">
          <div style="color: red">/ BNB {{ totalRechargeCunt.unCollectBnb}}</div>
        </div>
        <div class="item_warp" style="margin-left: 10px;">
          <div style="color: red">/ BTC {{ totalRechargeCunt.unCollectBtc}}</div>
        </div> -->
        <div class="item_warp" style="margin-left: 10px;">
          <div style="color: red">/ ETH {{ totalRechargeCunt.unCollectEth}}</div>
        </div>
        <div class="item_warp" style="margin-left: 10px;">
          <div style="color: red">/ USDC {{ totalRechargeCunt.unCollectUsdc}}</div>
        </div>
        <div class="item_warp" style="margin-left: 10px;">
          <div style="color: red">/ DAI {{ totalRechargeCunt.unCollectDai}}</div>
        </div>
      </div>
      <!-- 表单 -->
      <el-table
        ref="gridTable"
        v-loading="loading"
        :data="tableData"
        tooltip-effect="dark"
        :stripe="true"
        :border="true"
        height="calc(100vh - 240px )"
        style="width: 1431px"
        size="mini"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="50" />
        <el-table-column prop="uid" label="用户" width="100" />
        <el-table-column prop="bnbAddress" label="钱包地址" width="150" />
        <el-table-column prop="polUnCollectAmount" label="未归集USDT" width="110" />
        <el-table-column prop="polCollectedAmount" label="已归集USDT" width="120" />
        <!-- <el-table-column prop="bnbTrx" label="未归集TRX" width="100" /> -->
        <el-table-column prop="polPol" label="未归集POL" width="100" />
        <el-table-column prop="polCollectUsdtStatus" label="USDT归集状态" width="130">
          <template slot-scope="scope">
            <div v-if="scope.row.polCollectUsdtStatus == 0">无</div>
            <div v-if="scope.row.polCollectUsdtStatus == 1" style="color:#06CC00">归集成功</div>
            <div v-if="scope.row.polCollectUsdtStatus == 2" style="color:red">归集失败</div>
            <div v-if="scope.row.polCollectUsdtStatus == 3" style="color:#ccc">归集中</div>
          </template>
        </el-table-column>
        <el-table-column prop="polCollectOtherStatus" label="其他币种归集状态" width="140">
          <template slot-scope="scope">
            <div v-if="scope.row.polCollectOtherStatus == 0">无</div>
            <div v-if="scope.row.polCollectOtherStatus == 1" style="color:#06CC00">归集成功</div>
            <div v-if="scope.row.polCollectOtherStatus == 2" style="color:red" >归集失败</div>
            <div v-if="scope.row.polCollectOtherStatus == 3" style="color:#ccc">归集中</div>
          </template>
        </el-table-column>
        <el-table-column prop="polUsdc" label="未归集USDC" width="130"/>
        <el-table-column prop="polEth" label="未归集ETH" width="130"/>
        <el-table-column prop="polDai" label="未归集DAI" width="130"/>
        <el-table-column prop="createDate" label="创建时间" width="170" />
        <el-table-column prop="address" label="操作" width="100">
          <template slot-scope="scope">
            <el-button
              type="primary" 
              class="edit-button"
              size="mini"
              style="width:70px;margin-bottom: 5px;"
              @click="freshUSDT(scope.row)"
              >刷新</el-button
            >
           <el-button
              type="primary" 
              size="mini"
              style="background: #008A8B;border:1px solid #008A8B;width:70px;margin-left: 0px;"
              @click="freshAssetOther(scope.row)"
              >刷新其他</el-button
            >
          </template>
        </el-table-column>
        <!-- <el-table-column prop="vipLevel" label="VIP" width="100" />
        <el-table-column prop="amount" label="余额" width="100" />
        <el-table-column prop="totalRecharge" label="总充值" width="100" />
        <el-table-column prop="memo" label="总提现" width="100" /> -->
        
      </el-table>
      <!-- 分页 -->
      <pagination
        v-show="total > 0"
        :total="total"
        :page.sync="pageNum"
        :limit.sync="pageSize"
        @pagination="getList"
      />
      <!-- 归集主账号 -->
      <el-dialog
        :visible.sync="editPasswordShow"
        width="400px"
        :center="true"
        title="主账号选择"
        :close-on-click-modal="false"
      >
        <div>
          <div style="margin: 15px 0" class="radioGroup">
            <el-radio-group v-model="masterAccountId">
              <el-radio style="white-space: break-spaces;" v-for="(item,index) in masterAccountList" :key="index" :label="item.id">
                {{item.address}}<span v-if="item.memo" style="margin-left: 10px;">({{item.memo}})</span>
              </el-radio>
            </el-radio-group>
          </div>
          <div style="display: flex;justify-content: center;" v-if="type == 4">
            <el-button
              type="primary"
              class="edit-button"
              @click="collect()"
              >确定</el-button
            >
          </div>
          <div style="display: flex;justify-content: center;" v-if="type == 1">
            <el-button
              type="primary"
              class="edit-button"
              @click="collectBnb()"
              >确定</el-button
            >
          </div>
          <div style="display: flex;justify-content: center;" v-if="type == 2">
            <el-button
              type="primary"
              class="edit-button"
              @click="collectTrx()"
              >确定</el-button
            >
          </div>
          <div style="display: flex;justify-content: center;" v-if="type == 3">
            <el-button
              type="primary"
              class="edit-button"
              @click="oneCollect()"
              >确定</el-button
            >
          </div>
          <div style="display: flex;justify-content: center;" v-if="type == 5">
            <el-button
              type="primary"
              class="edit-button"
              @click="collectOther()"
              >确定</el-button
            >
          </div>
        </div>
      </el-dialog>
      <!-- 详情 -->
      <el-dialog
        :visible.sync="dialogVisible"
        width="700px"
        title="详情"
        :close-on-click-modal="false"
      >
        <div>
            <!-- 表单 -->
      <el-table
        ref="gridTable"
        v-loading="loading"
        :data="collectList"
        tooltip-effect="dark"
        :stripe="true"
        :border="true"
        height="740px"
        style="width: 591px"
        size="mini"
      >
        <el-table-column prop="uid" label="用户" width="100" />
        <el-table-column prop="totalAmount" label="状态" width="100">
          <template slot-scope="scope">
            <div v-if="scope.row.status == 0" style="color:#ABABAB">进行中</div>
            <div v-if="scope.row.status == 1" style="color:#06CC00">已完成</div>
            <div v-if="scope.row.status == 2" style="color:#FF0000">失败</div>
          </template>
        </el-table-column>
        <el-table-column prop="totalTeamAmount" label="转入BNB" width="130">
          <template slot-scope="scope">
            <div v-if="scope.row.zhuanBnbStatus == 0">未转入</div>
            <div v-if="scope.row.zhuanBnbStatus == 1">已转入</div>
          </template>
        </el-table-column>
        <el-table-column prop="investTotalAmount" label="归集USDT" width="130">
          <template slot-scope="scope">
            <div v-if="scope.row.usdtStatus == 0">未归集</div>
            <div v-if="scope.row.usdtStatus == 1">已归集</div>
          </template>
        </el-table-column>
        <el-table-column prop="serviceChargeTotal" label="归集BNB" width="130">
          <template slot-scope="scope">
            <div v-if="scope.row.collectBnbStatus == 0">未归集</div>
            <div v-if="scope.row.collectBnbStatus == 1">已归集</div>
          </template>
        </el-table-column>
        <el-table-column prop="bnbBtc" label="未归集BTC" width="130"/>
        
        
        </el-table>
        </div>
      </el-dialog>
    </div>
  </template>
  <script>
  import Pagination from "@/components/Pagination"; // 引入分页器
  import VueUeditorWrap from "vue-ueditor-wrap"; // ES6 Module
  import validEmail from "@/utils/validate"; // 引入邮箱验证方法
  import md5 from "js-md5"; // 引入Md5加密
  
  export default {
    name: "Management",
    components: { Pagination, VueUeditorWrap },
    data() {
      return {
        tableData: [], // 展示的表单信息
        total: 0, // 总数
        pageNum: 1, // 页码值
        pageSize: 20, // 页大小
        loading: false, // 表格加
        uid: "",
        username: "",
        unCollectAmount: "",
        unCollectTrx: "",
        unCollectBtc: "",
        unCollectEth: "",
        unCollectDai: "",
        unCollectUsdc: "",
        unCollectPOL:"",
        unCollectDoge: "",
        address: "",
        delegatedEnergy: "",
        collectOtherStatus: "",
        hasTrx: "",
        hasEnergy: "",
        collectUsdtStatus: "",
        collectTrxStatus: "",
        isHadCollectAmount: "",
        totalRechargeCunt: {},
        multipleSelection:[],
        editPasswordShow:false,
        dialogVisible:false,
        masterAccountId:'',
        masterAccountList:[],
        collectList:[],
        type:1,
        ca1:0,
        ca2:0,
        time:null,
        loadingBatch:false,
        ticket:''
      };
    },
    mounted() {
      this.getDate();
      // this.collectView()
      // this.time = setInterval(()=>{
      //      this.collectView()
      // },1000)
    },
    beforeDestroy(){
      clearInterval(this.time)
    },
    methods: {
      // 选择或者取消行，支持全选
      handleSelectionChange(val) {
        this.multipleSelection = val;
      },
      // 筛选
      select() {
        this.pageNum = 1;
        this.getList();
      },
      getDate() {
        this.getList();
      },
      // 主体
      getZhuList(type,ticket) {
        if (!this.multipleSelection || this.multipleSelection.length < 1) {
          return this.$message.info("你并没有选中任何选项");
        }
        this.type = type
        if(type == 5){
          this.ticket = ticket
        }
        this.$api.Polygon
          .masterAccountsT()
          .then((res) => {
            if(res.length > 0){
              this.editPasswordShow = true
              this.masterAccountList = res
            }else{
              this.$message.info("暂无主体");
            }
          })
          .catch((err) => {
            this.$message.error(err || "服务器错误，请稍后重试");
          })
          .finally(() => {
            this.loading = false;
          });
      },
      // 一键刷新
      batchFreshUSDT(type) {
        if (!this.multipleSelection || this.multipleSelection.length < 1) {
          return this.$message.info("你并没有选中任何选项");
        }
        if(this.loadingBatch) return
        this.loadingBatch = true
        var ids = [];
          this.multipleSelection.forEach((item) => {
            ids.push(item.id);
          });
          var params = {
            ids: ids.toString()
          };
        this.$api.Polygon
          .batchFreshUSDT(params)
          .then((res) => {
            this.$message.success(res);
            this.loadingBatch = false
              this.getList();
          })
          .catch((err) => {
            this.$message.error(err || "服务器错误，请稍后重试");
            this.loadingBatch = false
          })
          .finally(() => {
            this.loadingBatch = false
          });
      },
      // 一键刷新其他币种
       batchFreshAssetOther(type) {
        if (!this.multipleSelection || this.multipleSelection.length < 1) {
          return this.$message.info("你并没有选中任何选项");
        }
        if(this.loadingBatch) return
        this.loadingBatch = true
        var ids = [];
          this.multipleSelection.forEach((item) => {
            ids.push(item.id);
          });
          var params = {
            ids: ids.toString()
          };
        this.$api.Polygon
          .batchFreshAssetOther(params)
          .then((res) => {
            this.$message.success(res);
            this.loadingBatch = false
              this.getList();
          })
          .catch((err) => {
            this.$message.error(err || "服务器错误，请稍后重试");
            this.loadingBatch = false
          })
          .finally(() => {
            this.loadingBatch = false
          });
      },
      // 重置归集状态
      resetStatus(type) {
        if (!this.multipleSelection || this.multipleSelection.length < 1) {
          return this.$message.info("你并没有选中任何选项");
        }
        if(this.loadingBatch) return
        this.loadingBatch = true
        var ids = [];
          this.multipleSelection.forEach((item) => {
            ids.push(item.id);
          });
          var params = {
            ids: ids.toString()
          };
        this.$api.Polygon
          .resetStatus(params)
          .then((res) => {
            this.$message.success(res);
              this.getList();
          })
          .catch((err) => {
            this.$message.error(err || "服务器错误，请稍后重试");
            this.loadingBatch = false
          })
          .finally(() => {
            this.loadingBatch = false
          });
      },
      // 获取表单信息
      getList() {
        var params = {
          pageNumber: this.pageNum,
          pageSize: this.pageSize,
          uid: this.uid,
          username: this.username,
          unCollectAmount: this.unCollectAmount,
          unCollectTrx: this.unCollectTrx,
          address: this.address,
          delegatedEnergy: this.delegatedEnergy,
          hasPol: this.hasTrx,
          hasEnergy: this.hasEnergy,
          isHadCollectAmount: this.isHadCollectAmount,
          collectUsdtStatus: this.collectUsdtStatus,
          collectTrxStatus: this.collectTrxStatus,
          unCollectBtc: this.unCollectBtc,
          unCollectEth: this.unCollectEth,
          unCollectDai: this.unCollectDai,
           unCollectPOL: this.unCollectPOL,
          unCollectUsdc: this.unCollectUsdc,
          unCollectDoge: this.unCollectDoge,
          collectOtherStatus: this.collectOtherStatus
        };
        this.loading = true;
        this.$refs.gridTable.bodyWrapper.scrollTop = 0;
        this.$api.Polygon
          .memberCollectionList(params)
          .then((res) => {
            this.tableData = res.page.records;
            this.total = res.page.total;
            this.totalRechargeCunt = {
              unCollectBnb:res.unCollectBnb,
              unCollectBtc:res.unCollectBtc,
              unCollectDoge:res.unCollectDoge,
              unCollectEth:res.unCollectEth,
              unCollectTrx:res.unCollectTrx,
              unCollectUsdc:res.unCollectUsdc,
              unCollectDai:res.unCollectDai,
              unCollectUsdt:res.unCollectUsdt
            }
          })
          .catch((err) => {
            this.$message.error(err || "服务器错误，请稍后重试");
          })
          .finally(() => {
            this.loading = false;
          });
      },
      // 刷新
      freshUSDT(row){
         this.$api.Polygon
          .freshUSDT({id:row.id})
          .then((res) => {
            this.$message.success(res);
            this.getDate();
          })
          .catch((err) => {
            this.$message.error(err || "服务器错误，请稍后重试");
          })
          .finally(() => {
            this.loading = false;
          });
      },
      // 刷新其他
      freshAssetOther(row){
         this.$api.Polygon
          .freshAssetOther({id:row.id})
          .then((res) => {
            this.$message.success(res);
            this.getDate();
          })
          .catch((err) => {
            this.$message.error(err || "服务器错误，请稍后重试");
          })
          .finally(() => {
            this.loading = false;
          });
      },
      // 代理能量
      getDelegatedEnergy(){
        if (!this.multipleSelection || this.multipleSelection.length < 1) {
          return this.$message.info("你并没有选中任何选项");
        }
        this.$confirm("是否代理能量?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            var ids = [];
          this.multipleSelection.forEach((item) => {
            ids.push(item.id);
          });
          var params = {
            ids: ids.toString()
          };
          this.$api.Polygon
            .delegatedEnergy(params)
            .then((res) => {
              this.$message.success(res);
              this.getList();
              this.editPasswordShow = false
            })
            .catch((err) => {
              this.$message.error(err || "服务器错误，请稍后重试");
            })
          })
          .catch(() => {
            
          });
      },
      // 回收能量
      undelegateResource(){
        if (!this.multipleSelection || this.multipleSelection.length < 1) {
          return this.$message.info("你并没有选中任何选项");
        }
        this.$confirm("是否回收能量?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            var ids = [];
          this.multipleSelection.forEach((item) => {
            ids.push(item.id);
          });
          var params = {
            ids: ids.toString()
          };
          this.$api.Polygon
            .undelegateResource(params)
            .then((res) => {
              this.$message.success(res);
              this.getList();
              this.editPasswordShow = false
            })
            .catch((err) => {
              this.$message.error(err || "服务器错误，请稍后重试");
            })
          })
          .catch(() => {
            
          });
      },
      // 转TRX
      zhuanTrx(){
        if (!this.multipleSelection || this.multipleSelection.length < 1) {
          return this.$message.info("你并没有选中任何选项");
        }
        this.$confirm("是否转POL?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            var ids = [];
          this.multipleSelection.forEach((item) => {
            ids.push(item.id);
          });
          var params = {
            ids: ids.toString()
          };
          this.$api.Polygon
            .zhuanBnb(params)
            .then((res) => {
              this.$message.success(res);
              this.getList();
              this.editPasswordShow = false
            })
            .catch((err) => {
              this.$message.error(err || "服务器错误，请稍后重试");
            })
          })
          .catch(() => {
            
          });
      },
      // 归集USDT
      collect(){
        var ids = [];
          this.multipleSelection.forEach((item) => {
            ids.push(item.id);
          });
          var params = {
            ids: ids.toString(),
            masterAccountId:this.masterAccountId
          };
          this.$api.Polygon
            .collect(params)
            .then((res) => {
              this.$message.success(res);
              this.getList();
              this.editPasswordShow = false
            })
            .catch((err) => {
              this.$message.error(err || "服务器错误，请稍后重试");
            })
      },
      collectBnb(){
        var ids = [];
          this.multipleSelection.forEach((item) => {
            ids.push(item.id);
          });
          var params = {
            ids: ids.toString(),
            masterAccountId:this.masterAccountId
          };
          this.$api.Polygon
            .collectBnb(params)
            .then((res) => {
              this.$message.success(res);
              this.getList();
              this.editPasswordShow = false
            })
            .catch((err) => {
              this.$message.error(err || "服务器错误，请稍后重试");
            })
      },
      // 归集TRX
      collectTrx(){
        var ids = [];
          this.multipleSelection.forEach((item) => {
            ids.push(item.id);
          });
          var params = {
            ids: ids.toString(),
            masterAccountId:this.masterAccountId
          };
          this.$api.Polygon
            .collectTrx(params)
            .then((res) => {
              this.$message.success(res);
              this.getList();
              this.editPasswordShow = false
            })
            .catch((err) => {
              this.$message.error(err || "服务器错误，请稍后重试");
            })
      },
      // 一键归U
      oneCollect(){
        var ids = [];
          this.multipleSelection.forEach((item) => {
            ids.push(item.id);
          });
          var params = {
            ids: ids.toString(),
            masterAccountId:this.masterAccountId
          };
          this.$api.Polygon
            .oneCollect(params)
            .then((res) => {
              this.$message.success(res);
              this.getList();
              this.editPasswordShow = false
            })
            .catch((err) => {
              this.$message.error(err || "服务器错误，请稍后重试");
            })
      },
      collectOther(){
        var ids = [];
          this.multipleSelection.forEach((item) => {
            ids.push(item.id);
          });
          var params = {
            ids: ids.toString(),
            masterAccountId:this.masterAccountId,
            ticket:this.ticket
          };
          this.$api.Polygon
            .collectOther(params)
            .then((res) => {
              this.$message.success(res);
              this.getList();
              this.editPasswordShow = false
            })
            .catch((err) => {
              this.$message.error(err || "服务器错误，请稍后重试");
            })
      },
      // 清空归集进度
      collectListRemove(){
        this.$confirm("是否清空归集进度?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
          this.$api.Polygon
            .collectListRemove()
            .then((res) => {
              this.$message.success(res);
              this.getList();
              this.editPasswordShow = false
            })
            .catch((err) => {
              this.$message.error(err || "服务器错误，请稍后重试");
            })
          })
          .catch(() => {
            
          });
      },
      // 归集进度
      collectView(){
        this.$api.Polygon
            .collectView()
            .then((res) => {
              this.ca1 = res.ca1
              this.ca2 = res.ca2
            })
            .catch((err) => {
              this.$message.error(err || "服务器错误，请稍后重试");
            })
      },
      getCollectList(){
        this.dialogVisible = true
        this.$api.Polygon
            .collectList()
            .then((res) => {
              this.collectList = res
            })
            .catch((err) => {
              this.$message.error(err || "服务器错误，请稍后重试");
            })
      }
    },
  };
  </script>
  <style lang="scss" scoped>
  .role_warp {
    width: 100%;
    overflow: hidden;
    font-size: 14px;
    padding: 10px;
    box-sizing: border-box;
    overflow: hidden;
    width: 100%;
    .role_heard_tool {
      margin-bottom: 10px;
      display: flex;
      align-items: center;
      flex-wrap: wrap;
    }
    .edit_titile {
      .dialog_input {
        // width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-around;
        width: 70%;
        span {
          flex: 1;
          display: flex;
          justify-content: flex-end;
          margin-right: 20px;
        }
        .el-input {
          flex: 3;
        }
      }
    }
    .tree {
      margin-top: 25px;
      display: flex;
      justify-content: space-around;
    }
    .authority_info {
      margin-top: 25px;
    }
  }
  .el-input {
    width: 70%;
    
    
  }
  .guiJi{
    display: flex;
    align-items: center;
    margin-left: 10px;
  }
  .guiJi_title{
    color: #6663FF;
    margin-right: 10px;
  }
  ::v-deep .el-radio{
    margin-bottom: 10px !important;
  }
  </style>
  